/**
 * Checklist-level vault gate (owner design, test pass 2026-09-04).
 *
 * The server refuses vault writes for accounts without vault access — but
 * letting someone fill a whole form and denying at Save is hostile. This
 * gate fires where the intent starts: the checklist's "Click to Complete"
 * button. Completed items keep their "Review Information" path untouched —
 * anything a user entered while entitled stays viewable forever.
 *
 * "Upgrade" routes letter-first users to the tier ladder (Levels) and
 * legacy users to the subscription screen.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Alert } from 'react-native';

export function guardVaultEdit(
  canEditData: boolean,
  navigation: any,
  proceed: () => void,
): void {
  if (canEditData) {
    proceed();
    return;
  }
  Alert.alert(
    'Upgrade to add information',
    "Adding to your vault isn't part of your current plan. Everything you've " +
      'already saved stays viewable, and your letters are never affected.',
    [
      { text: 'OK', style: 'cancel' },
      {
        text: 'Upgrade',
        onPress: async () => {
          let isLetterFirst = false;
          try {
            const raw = await AsyncStorage.getItem('user');
            isLetterFirst = ((JSON.parse(raw ?? '{}')?.onboardingVersion ?? 0) as number) >= 2;
          } catch {
            // Fall through to the legacy subscription screen.
          }
          if (isLetterFirst) {
            navigation.navigate('LetterFirst', { screen: 'LetterLevels' });
          } else {
            navigation.navigate('Profile', { screen: 'SubscriptionManagement' });
          }
        },
      },
    ],
  );
}
